module.exports = __webpack_public_path__ + "img/bahelfcreate_sample.36e0f3ad.png";